module.exports = __webpack_public_path__ + "0fc6a10c9ac11a5c045d33032067889d.svg";